import { useEffect, useRef, useState } from 'react';

import './pwa-install.d';

const InstallPrompt = () => {
  const loadedRef = useRef(false);
  // The <pwa-install> Lit web component is client-only, so rendering it during
  // SSR makes hydration mismatch and React replaces the whole subtree (a flicker
  // on every SSR page). Only render it after mount, matching the empty server HTML.
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    if (loadedRef.current) return;
    loadedRef.current = true;
    import('@khmyznikov/pwa-install').catch(() => {});
  }, []);

  if (!mounted) return null;

  return (
    <pwa-install
      manual-apple
      manual-chrome
      name="ConstructionYardSale"
      description="Buy and sell construction surplus. Notifications for new offers, replies, and payouts work like a native app once installed."
      styles={JSON.stringify({ '--tint-color': 'hsl(var(--primary))' })}
    />
  );
};

export default InstallPrompt;
